import React, { useEffect, useState } from "react";
import NewTopNavBar from "../NewTopNavBar";
import axios from "axios";
import { API_BASE_URL } from "../../utils/config";
import { MdArticle } from "react-icons/md";
import { FaLinkedin } from "react-icons/fa";
import { Spinner } from "react-bootstrap";
import LikeImg from "../../Img/blueLike.png";
import Col from "react-bootstrap/Col";
import Nav from "react-bootstrap/Nav";
import Row from "react-bootstrap/Row";
import Tab from "react-bootstrap/Tab";
import Select from "react-select";
import ViewImg from "../../Img/icons8-view-24.png";
import OpenPlatformNavbar from "../OpenPlatformNavbar";
import {
    Link,
    Route,
    Router,
    useNavigate,
    useLocation,
} from "react-router-dom";
import { RiH4 } from "react-icons/ri";
import InnerHamburgerNavigation from "../InnerHamburgerNavigation";
import HamburgerNavigation from "../HamburgerNavigation";
import { useLog } from "../../context/LogContext";
import { Chart } from "react-google-charts";
import { Bar } from 'react-chartjs-2';
import { Chart as ChartJS, BarElement, CategoryScale, LinearScale, Title, Tooltip, Legend } from 'chart.js';

const AnaliticsDasboard = () => {
    let bearerToken = localStorage.getItem("jwt_token");
    const [totalLike, setTotalLike] = useState();
    const [totalArticle, setTotalArticle] = useState();
    const [loading, setLoading] = useState(false);
    const [totalCategories, setTotalCategories] = useState();
    const [resentWeekFiveArticles, setResentWeekFiveArticles] = useState([]);
    const [resentMonthFiveArticles, setResentMonthFiveArticles] = useState([]);
    const [showArticles, setShowArticles] = useState([])
    const [currentWeekLikedPosts, setCurrentWeekLikedPosts] = useState([]);
    const [currentMonthLikedPosts, setCurrentMonthLikedPosts] = useState([]);
    const [currentweeksViewedArticle, setCurrentWeeksViewedArticle] = useState(
        []
    );
    const [currentMonthsViewedArticle, setCurrentMonthssViewedArticle] = useState(
        []
    );
    const [dataArticles, setDataArticles] = useState([])
    const [storage, setStorage] = useState({
        totalStorage: 0,
        usedStorage: 0
    })
    const [isChecked, setIsChecked] = useState(false);
    const [options, setOptions] = useState([]);
    const [selectedValue, setSelectedValue] = useState('recent');
    const [categories, setCategories] = useState("");
    const [selectedTenant, setSelectedTenant] = useState(null);
    const [isDisabled, setIsDisabled] = useState(true);
    const [user_roles, setUser_rolesRoles] = useState({
        admin: 0,
        editor: 0,
        author: 0,
        reader: 0
    })
    const [newArticleThisWeek, setNewArticleThisWeek] = useState([]);
    const { logApiRequest } = useLog();
    const navigate = useNavigate();
    const userRolles = localStorage.getItem("roles");

    let config = {
        headers: {
            Authorization: `Bearer ${bearerToken}`,
            "Content-Type": "application/json",
        },
    };
    const currentUserId = localStorage.getItem("current_user_Id");
    const thisWeakMostLikedArticles = () => {
        const request = {
            method: "GET",
            url: `${API_BASE_URL}/wp-json/custom-like/v1/liked-posts`,
        };
        axios
            .get(`${API_BASE_URL}/wp-json/custom-like/v1/liked-posts`, config)
            .then((res) => {
                console.log("line19=", res.data);
                logApiRequest(request, res);
            })
            .catch((err) => {
                console.log(err);
                logApiRequest(request, err.response || { status: err.message });
            });
    };

    const gotToArticlePage = (postId) => {
        localStorage.setItem("postId", postId);
        navigate(`/single-article?id=${postId}`);
    };

    const getTenentData = () => {
        axios
            .get(`${API_BASE_URL}/wp-json/custom-api/v1/get-data`, config)
            .then((res) => {
                console.log("telentData=", res.data);
                setOptions(
                    res.data.map((item) => ({
                        value: item.id,
                        label: item.tenent,
                        categgory: item.category,
                    }))
                );
                const selectedOption = res.data.filter((data) => {
                    if (data.tenent_user_id == currentUserId) {
                        return data;
                    }
                });
            })
            .catch((err) => {
                console.log(err);
            });
    };

    const handleChangeSelectArticles = (event) => {
        const value = event.target.value;
        setSelectedValue(value);
        setIsChecked(false)
        // alert(value)
        if (value == "viewed") {
            // setShowArticles(currentMonthsViewedArticle)
            console.log("line136data=", currentMonthsViewedArticle)
            setDataArticles([
                ["Task", "Views", { role: "style" }],
                [currentMonthsViewedArticle[0]?.title.rendered.length > 30 ? currentMonthsViewedArticle[0]?.title.rendered.slice(0, 30) + "..." : currentMonthsViewedArticle[0]?.title.rendered, parseInt(currentMonthsViewedArticle[0]?.unique_author_views), "color: #A6B2FF"], // Blue
                // [null, null, "opacity: 0"],     // Dummy data for gap
                [currentMonthsViewedArticle[1]?.title.rendered.length > 30 ? currentMonthsViewedArticle[1]?.title.rendered.slice(0, 30) + "..." : currentMonthsViewedArticle[1]?.title.rendered, parseInt(currentMonthsViewedArticle[1]?.unique_author_views), "color: #FCFFA7"], // Red
                // [null, null, "opacity: 0"],     // Dummy data for gap
                [currentMonthsViewedArticle[2]?.title.rendered.length > 30 ? currentMonthsViewedArticle[2]?.title.rendered.slice(0, 30) + "..." : currentMonthsViewedArticle[2]?.title.rendered, parseInt(currentMonthsViewedArticle[2]?.unique_author_views), "color: #C1FFAA"], // Yellow
                // [null, null, "opacity: 0"],     // Dummy data for gap
                [currentMonthsViewedArticle[3]?.title.rendered.length > 30 ? currentMonthsViewedArticle[3]?.title.rendered.slice(0, 30) + "..." : currentMonthsViewedArticle[3]?.title.rendered, parseInt(currentMonthsViewedArticle[3]?.unique_author_views), "color: #ACFCFF"], // Green
                // [null, null, "opacity: 0"],     // Dummy data for gap
                [currentMonthsViewedArticle[4]?.title.rendered.length > 30 ? currentMonthsViewedArticle[4]?.title.rendered.slice(0, 30) + "..." : currentMonthsViewedArticle[4]?.title.rendered, parseInt(currentMonthsViewedArticle[4]?.unique_author_views), "color: #FFDA9F"], // Purple)
            ])
        } else if (value === "recent") {
            // setShowArticles(resentMonthFiveArticles)
            setDataArticles([
                ["Task", "Views", { role: "style" }],
                [resentMonthFiveArticles[0]?.title.rendered.length > 30 ? resentMonthFiveArticles[0]?.title.rendered.slice(0, 30) + "..." : resentMonthFiveArticles[0]?.title.rendered, parseInt(resentMonthFiveArticles[0]?.unique_author_views), "color: #A6B2FF"], // Blue
                // [null, null, "opacity: 0"],     // Dummy data for gap
                [resentMonthFiveArticles[1]?.title.rendered.length > 30 ? resentMonthFiveArticles[1]?.title.rendered.slice(0, 30) + "..." : resentMonthFiveArticles[1]?.title.rendered, parseInt(resentMonthFiveArticles[1]?.unique_author_views), "color: #FCFFA7"], // Red
                // [null, null, "opacity: 0"],     // Dummy data for gap
                [resentMonthFiveArticles[2]?.title.rendered.length > 30 ? resentMonthFiveArticles[2]?.title.rendered.slice(0, 30) + "..." : resentMonthFiveArticles[2]?.title.rendered, parseInt(resentMonthFiveArticles[2]?.unique_author_views), "color: #C1FFAA"], // Yellow
                // [null, null, "opacity: 0"],     // Dummy data for gap
                [resentMonthFiveArticles[3]?.title.rendered.length > 30 ? resentMonthFiveArticles[3]?.title.rendered.slice(0, 30) + "..." : resentMonthFiveArticles[3]?.title.rendered, parseInt(resentMonthFiveArticles[3]?.unique_author_views), "color: #ACFCFF"], // Green
                // [null, null, "opacity: 0"],     // Dummy data for gap
                [resentMonthFiveArticles[4]?.title.rendered.length > 30 ? resentMonthFiveArticles[4]?.title.rendered.slice(0, 30) + "..." : resentMonthFiveArticles[4]?.title.rendered, parseInt(resentMonthFiveArticles[4]?.unique_author_views), "color: #FFDA9F"], // Purple)
            ])
        } else if (value == "liked") {
            // setShowArticles(currentMonthLikedPosts)
            setDataArticles([
                ["Task", "Views", { role: "style" }],
                [currentMonthLikedPosts[0]?.title.rendered.length > 30 ? currentMonthLikedPosts[0]?.title.rendered.slice(0, 30) + "..." : currentMonthLikedPosts[0]?.title.rendered, parseInt(currentMonthLikedPosts[0]?.unique_author_views), "color: #A6B2FF"], // Blue
                // [null, null, "opacity: 0"],     // Dummy data for gap
                [currentMonthLikedPosts[1]?.title.rendered.length > 30 ? currentMonthLikedPosts[1]?.title.rendered.slice(0, 30) + "..." : currentMonthLikedPosts[1]?.title.rendered, parseInt(currentMonthLikedPosts[1]?.unique_author_views), "color: #FCFFA7"], // Red
                // [null, null, "opacity: 0"],     // Dummy data for gap
                [currentMonthLikedPosts[2]?.title.rendered.length > 30 ? currentMonthLikedPosts[2]?.title.rendered.slice(0, 30) + "..." : currentMonthLikedPosts[2]?.title.rendered, parseInt(currentMonthLikedPosts[2]?.unique_author_views), "color: #C1FFAA"], // Yellow
                // [null, null, "opacity: 0"],     // Dummy data for gap
                [currentMonthLikedPosts[3]?.title.rendered.length > 30 ? currentMonthLikedPosts[3]?.title.rendered.slice(0, 30) + "..." : currentMonthLikedPosts[3]?.title.rendered, parseInt(currentMonthLikedPosts[3]?.unique_author_views), "color: #ACFCFF"], // Green
                // [null, null, "opacity: 0"],     // Dummy data for gap
                [currentMonthLikedPosts[4]?.title.rendered.length > 30 ? currentMonthLikedPosts[4]?.title.rendered.slice(0, 30) + "..." : currentMonthLikedPosts[4]?.title.rendered, parseInt(currentMonthLikedPosts[4]?.unique_author_views), "color: #FFDA9F"], // Purple)
            ])
        }

        // Call your function here with the selected value
        // handleSelection(value);
    };
    // console.log('dataArticles', dataArticles[1][0])
    const handleToggle = (event) => {
        // alert(event.target.value)
        if (!isChecked) {
            if (selectedValue == "viewed") {
                // setShowArticles(currentMonthsViewedArticle)
                console.log("line136data=", currentweeksViewedArticle)
                setDataArticles([
                    ["Task", "Views", { role: "style" }],
                    [currentweeksViewedArticle[0]?.title.rendered.length > 30 ? currentweeksViewedArticle[0]?.title.rendered.slice(0, 30) + "..." : currentweeksViewedArticle[0]?.title.rendered, parseInt(currentweeksViewedArticle[0]?.unique_author_views), "color: #A6B2FF"], // Blue
                    // [null, null, "opacity: 0"],     // Dummy data for gap
                    [currentweeksViewedArticle[1]?.title.rendered.length > 30 ? currentweeksViewedArticle[1]?.title.rendered.slice(0, 30) + "..." : currentweeksViewedArticle[1]?.title.rendered, parseInt(currentweeksViewedArticle[1]?.unique_author_views), "color: #FCFFA7"], // Red
                    // [null, null, "opacity: 0"],     // Dummy data for gap
                    [currentweeksViewedArticle[2]?.title.rendered.length > 30 ? currentweeksViewedArticle[2]?.title.rendered.slice(0, 30) + "..." : currentweeksViewedArticle[2]?.title.rendered, parseInt(currentweeksViewedArticle[2]?.unique_author_views), "color: #C1FFAA"], // Yellow
                    // [null, null, "opacity: 0"],     // Dummy data for gap
                    [currentweeksViewedArticle[3]?.title.rendered.length > 30 ? currentweeksViewedArticle[3]?.title.rendered.slice(0, 30) + "..." : currentweeksViewedArticle[3]?.title.rendered, parseInt(currentweeksViewedArticle[3]?.unique_author_views), "color: #ACFCFF"], // Green
                    // [null, null, "opacity: 0"],     // Dummy data for gap
                    [currentweeksViewedArticle[4]?.title.rendered.length > 30 ? currentweeksViewedArticle[4]?.title.rendered.slice(0, 30) + "..." : currentweeksViewedArticle[4]?.title.rendered, parseInt(currentweeksViewedArticle[4]?.unique_author_views), "color: #FFDA9F"], // Purple)
                ])
            } else if (selectedValue === "recent") {
                // setShowArticles(resentMonthFiveArticles)
                setDataArticles([
                    ["Task", "Views", { role: "style" }],
                    [resentWeekFiveArticles[0]?.title.rendered.length > 30 ? resentWeekFiveArticles[0]?.title.rendered.slice(0, 30) + "..." : resentWeekFiveArticles[0]?.title.rendered, parseInt(resentWeekFiveArticles[0]?.unique_author_views), "color: #A6B2FF"], // Blue
                    // [null, null, "opacity: 0"],     // Dummy data for gap
                    [resentWeekFiveArticles[1]?.title.rendered.length > 30 ? resentWeekFiveArticles[1]?.title.rendered.slice(0, 30) + "..." : resentWeekFiveArticles[1]?.title.rendered, parseInt(resentWeekFiveArticles[1]?.unique_author_views), "color: #FCFFA7"], // Red
                    // [null, null, "opacity: 0"],     // Dummy data for gap
                    [resentWeekFiveArticles[2]?.title.rendered.length > 30 ? resentWeekFiveArticles[2]?.title.rendered.slice(0, 30) + "..." : resentWeekFiveArticles[2]?.title.rendered, parseInt(resentWeekFiveArticles[2]?.unique_author_views), "color: #C1FFAA"], // Yellow
                    // [null, null, "opacity: 0"],     // Dummy data for gap
                    [resentWeekFiveArticles[3]?.title.rendered.length > 30 ? resentWeekFiveArticles[3]?.title.rendered.slice(0, 30) + "..." : resentWeekFiveArticles[3]?.title.rendered, parseInt(resentWeekFiveArticles[3]?.unique_author_views), "color: #ACFCFF"], // Green
                    // [null, null, "opacity: 0"],     // Dummy data for gap
                    [resentWeekFiveArticles[4]?.title.rendered.length > 30 ? resentWeekFiveArticles[4]?.title.rendered.slice(0, 30) + "..." : resentWeekFiveArticles[4]?.title.rendered, parseInt(resentWeekFiveArticles[4]?.unique_author_views), "color: #FFDA9F"], // Purple)
                ])
            } else if (selectedValue == "liked") {
                // setShowArticles(currentMonthLikedPosts)
                setDataArticles([
                    ["Task", "Views", { role: "style" }],
                    [currentWeekLikedPosts[0]?.title.rendered.length > 30 ? currentWeekLikedPosts[0]?.title.rendered.slice(0, 30) + "..." : currentWeekLikedPosts[0]?.title.rendered, parseInt(currentWeekLikedPosts[0]?.unique_author_views), "color: #A6B2FF"], // Blue
                    // [null, null, "opacity: 0"],     // Dummy data for gap
                    [currentWeekLikedPosts[1]?.title.rendered.length > 30 ? currentWeekLikedPosts[1]?.title.rendered.slice(0, 30) + "..." : currentWeekLikedPosts[1]?.title.rendered, parseInt(currentWeekLikedPosts[1]?.unique_author_views), "color: #FCFFA7"], // Red
                    // [null, null, "opacity: 0"],     // Dummy data for gap
                    [currentWeekLikedPosts[2]?.title.rendered.length > 30 ? currentWeekLikedPosts[2]?.title.rendered.slice(0, 30) + "..." : currentWeekLikedPosts[2]?.title.rendered, parseInt(currentWeekLikedPosts[2]?.unique_author_views), "color: #C1FFAA"], // Yellow
                    // [null, null, "opacity: 0"],     // Dummy data for gap
                    [currentWeekLikedPosts[3]?.title.rendered.length > 30 ? currentWeekLikedPosts[3]?.title.rendered.slice(0, 30) + "..." : currentWeekLikedPosts[3]?.title.rendered, parseInt(currentWeekLikedPosts[3]?.unique_author_views), "color: #ACFCFF"], // Green
                    // [null, null, "opacity: 0"],     // Dummy data for gap
                    [currentWeekLikedPosts[4]?.title.rendered.length > 30 ? currentWeekLikedPosts[4]?.title.rendered.slice(0, 30) + "..." : currentWeekLikedPosts[4]?.title.rendered, parseInt(currentWeekLikedPosts[4]?.unique_author_views), "color: #FFDA9F"], // Purple)
                ])
            }
        }
        if (isChecked) {
            if (selectedValue == "viewed") {
                // setShowArticles(currentMonthsViewedArticle)
                console.log("line136data=", currentMonthsViewedArticle)
                setDataArticles([
                    ["Task", "Views", { role: "style" }],
                    [currentMonthsViewedArticle[0]?.title.rendered.length > 30 ? currentMonthsViewedArticle[0]?.title.rendered.slice(0, 30) + "..." : currentMonthsViewedArticle[0]?.title.rendered, parseInt(currentMonthsViewedArticle[0]?.unique_author_views), "color: #A6B2FF"], // Blue
                    // [null, null, "opacity: 0"],     // Dummy data for gap
                    [currentMonthsViewedArticle[1]?.title.rendered.length > 30 ? currentMonthsViewedArticle[1]?.title.rendered.slice(0, 30) + "..." : currentMonthsViewedArticle[1]?.title.rendered, parseInt(currentMonthsViewedArticle[1]?.unique_author_views), "color: #FCFFA7"], // Red
                    // [null, null, "opacity: 0"],     // Dummy data for gap
                    [currentMonthsViewedArticle[2]?.title.rendered.length > 30 ? currentMonthsViewedArticle[2]?.title.rendered.slice(0, 30) + "..." : currentMonthsViewedArticle[2]?.title.rendered, parseInt(currentMonthsViewedArticle[2]?.unique_author_views), "color: #C1FFAA"], // Yellow
                    // [null, null, "opacity: 0"],     // Dummy data for gap
                    [currentMonthsViewedArticle[3]?.title.rendered.length > 30 ? currentMonthsViewedArticle[3]?.title.rendered.slice(0, 30) + "..." : currentMonthsViewedArticle[3]?.title.rendered, parseInt(currentMonthsViewedArticle[3]?.unique_author_views), "color: #ACFCFF"], // Green
                    // [null, null, "opacity: 0"],     // Dummy data for gap
                    [currentMonthsViewedArticle[4]?.title.rendered.length > 30 ? currentMonthsViewedArticle[4]?.title.rendered.slice(0, 30) + "..." : currentMonthsViewedArticle[4]?.title.rendered, parseInt(currentMonthsViewedArticle[4]?.unique_author_views), "color: #FFDA9F"], // Purple)
                ])
            } else if (selectedValue === "recent") {
                // setShowArticles(resentMonthFiveArticles)
                console.log('resentMonthFiveArticles', resentMonthFiveArticles)
                setDataArticles([
                    ["Task", "Views", { role: "style" }],
                    [resentMonthFiveArticles[0]?.title.rendered.length > 30 ? resentMonthFiveArticles[0]?.title.rendered.slice(0, 30) + "..." : resentMonthFiveArticles[0]?.title.rendered, parseInt(resentMonthFiveArticles[0]?.unique_author_views), "color: #A6B2FF"], // Blue
                    // [null, null, "opacity: 0"],     // Dummy data for gap
                    [resentMonthFiveArticles[1]?.title.rendered.length > 30 ? resentMonthFiveArticles[1]?.title.rendered.slice(0, 30) + "..." : resentMonthFiveArticles[1]?.title.rendered, parseInt(resentMonthFiveArticles[1]?.unique_author_views), "color: #FCFFA7"], // Red
                    // [null, null, "opacity: 0"],     // Dummy data for gap
                    [resentMonthFiveArticles[2]?.title.rendered.length > 30 ? resentMonthFiveArticles[2]?.title.rendered.slice(0, 30) + "..." : resentMonthFiveArticles[2]?.title.rendered, parseInt(resentMonthFiveArticles[2]?.unique_author_views), "color: #C1FFAA"], // Yellow
                    // [null, null, "opacity: 0"],     // Dummy data for gap
                    [resentMonthFiveArticles[3]?.title.rendered.length > 30 ? resentMonthFiveArticles[3]?.title.rendered.slice(0, 30) + "..." : resentMonthFiveArticles[3]?.title.rendered, parseInt(resentMonthFiveArticles[3]?.unique_author_views), "color: #ACFCFF"], // Green
                    // [null, null, "opacity: 0"],     // Dummy data for gap
                    [resentMonthFiveArticles[4]?.title.rendered.length > 30 ? resentMonthFiveArticles[4]?.title.rendered.slice(0, 30) + "..." : resentMonthFiveArticles[4]?.title.rendered, parseInt(resentMonthFiveArticles[4]?.unique_author_views), "color: #FFDA9F"], // Purple)
                ])
            } else if (selectedValue == "liked") {
                // setShowArticles(currentMonthLikedPosts)
                setDataArticles([
                    ["Task", "Views", { role: "style" }],
                    [currentMonthLikedPosts[0]?.title.rendered.length > 30 ? currentMonthLikedPosts[0]?.title.rendered.slice(0, 30) + "..." : currentMonthLikedPosts[0]?.title.rendered, parseInt(currentMonthLikedPosts[0]?.unique_author_views), "color: #A6B2FF"], // Blue
                    // [null, null, "opacity: 0"],     // Dummy data for gap
                    [currentMonthLikedPosts[1]?.title.rendered.length > 30 ? currentMonthLikedPosts[1]?.title.rendered.slice(0, 30) + "..." : currentMonthLikedPosts[1]?.title.rendered, parseInt(currentMonthLikedPosts[1]?.unique_author_views), "color: #FCFFA7"], // Red
                    // [null, null, "opacity: 0"],     // Dummy data for gap
                    [currentMonthLikedPosts[2]?.title.rendered.length > 30 ? currentMonthLikedPosts[2]?.title.rendered.slice(0, 30) + "..." : currentMonthLikedPosts[2]?.title.rendered, parseInt(currentMonthLikedPosts[2]?.unique_author_views), "color: #C1FFAA"], // Yellow
                    // [null, null, "opacity: 0"],     // Dummy data for gap
                    [currentMonthLikedPosts[3]?.title.rendered.length > 30 ? currentMonthLikedPosts[3]?.title.rendered.slice(0, 30) + "..." : currentMonthLikedPosts[3]?.title.rendered, parseInt(currentMonthLikedPosts[3]?.unique_author_views), "color: #ACFCFF"], // Green
                    // [null, null, "opacity: 0"],     // Dummy data for gap
                    [currentMonthLikedPosts[4]?.title.rendered.length > 30 ? currentMonthLikedPosts[4]?.title.rendered.slice(0, 30) + "..." : currentMonthLikedPosts[4]?.title.rendered, parseInt(currentMonthLikedPosts[4]?.unique_author_views), "color: #FFDA9F"], // Purple)
                ])
            }
        }
        setIsChecked(!isChecked);
    };
    useEffect(() => {
        // if (resentMonthFiveArticles.length > 0) {
        if (selectedValue == "recent") {
            // setShowArticles(resentMonthFiveArticles)
            //
            console.log("line136data=", resentMonthFiveArticles)
            setDataArticles([
                ["Task", "Views", { role: "style" }],
                [resentMonthFiveArticles[0]?.title.rendered.length > 30 ? resentMonthFiveArticles[0]?.title.rendered.slice(0, 30) + "..." : resentMonthFiveArticles[0]?.title.rendered, parseInt(resentMonthFiveArticles[0]?.unique_author_views), "color: #A6B2FF",], // Blue
                // [null, null, "opacity: 0"],     // Dummy data for gap
                [resentMonthFiveArticles[1]?.title.rendered.length > 30 ? resentMonthFiveArticles[1]?.title.rendered.slice(0, 30) + "..." : resentMonthFiveArticles[1]?.title.rendered, parseInt(resentMonthFiveArticles[1]?.unique_author_views), "color: #FCFFA7"], // Red
                // [null, null, "opacity: 0"],     // Dummy data for gap
                [resentMonthFiveArticles[2]?.title.rendered.length > 30 ? resentMonthFiveArticles[2]?.title.rendered.slice(0, 30) + "..." : resentMonthFiveArticles[2]?.title.rendered, parseInt(resentMonthFiveArticles[2]?.unique_author_views), "color: #C1FFAA"], // Yellow
                // [null, null, "opacity: 0"],     // Dummy data for gap
                [resentMonthFiveArticles[3]?.title.rendered.length > 30 ? resentMonthFiveArticles[3]?.title.rendered.slice(0, 30) + "..." : resentMonthFiveArticles[3]?.title.rendered, parseInt(resentMonthFiveArticles[3]?.unique_author_views), "color: #ACFCFF"], // Green
                // [null, null, "opacity: 0"],     // Dummy data for gap
                [resentMonthFiveArticles[4]?.title.rendered.length > 30 ? resentMonthFiveArticles[4]?.title.rendered.slice(0, 30) + "..." : resentMonthFiveArticles[4]?.title.rendered, parseInt(resentMonthFiveArticles[4]?.unique_author_views), "color: #FFDA9F"], // Purple)
            ])
            // 
        }
        // }
    }, [resentMonthFiveArticles.length]);
    //

    // const labels = [
    //     'Camptra sample',
    //     'Oracle APEX',
    //     'Oracle Exadata: next-generation ...',
    //     'Test Articles'
    // ];

    // const dataArticles = [
    //     ["Task", "Hours per Day", { role: "style" }],
    //     ["Work", 11, "color: #A6B2FF"], // Blue
    //     ["Eat", 2, "color: #FCFFA7"], // Red
    //     ["Commute", 2, "color: #C1FFAA"], // Yellow
    //     ["Watch TV", 2, "color: #ACFCFF"], // Green
    //     ["Sleep", 7, "color: #FFDA9F"], // Purple
    // ];

    useEffect(() => {


        axios.get(`${API_BASE_URL}/wp-json/custom/v1/file-tracking`).then((res) => {
            setStorage({ totalStorage: res.data.given_size, usedStorage: res.data.total_file_size_gb })
        }).catch((err) => {
            console.log(err)
        })

        // get all the users

        axios.get(`${API_BASE_URL}/wp-json/custom-user-api/v1/users`).then((res) => {
            res.data.forEach(user => {
                switch (user.user_roles) {
                    case 'subscriber':
                        user_roles.reader++;
                        break;
                    case 'editor':
                        user_roles.editor++;
                        break;
                    case 'author':
                        user_roles.author++;
                        break;
                }
            });
        }).catch((err) => {
            console.log(err)
        })

    }, [])

    //



    // 

    const optionsArticles = {
        // title: "My Daily Activities",
        bars: "horizontal", // Required for a horizontal bar chart
        legend: { position: "none" }, // No legend needed
        chartArea: {
            width: "80%",

            left: 320, // Increase left padding to add more gap between bars and labels

        }, // Adjust chart area
        bar: {
            groupWidth: "70%",
            // left: '500'
        }, // Width of the bars

        annotations: {
            alwaysOutside: false, // Values inside the bars
            textStyle: {
                fontSize: 18,
                color: "black", // Values inside the bars will be black
                bold: true,
            },
        },
        hAxis: {
            minValue: 0, // Start horizontal axis from 0
            gridlines: {
                color: "transparent", // Make vertical gridlines transparent to effectively hide them
            },
        },
        // minValue: 0, // Start horizontal axis from 0
        gridlines: {
            count: 0, // Remove vertical gridlines
        },
        vAxis: {
            textPosition: "out", // Labels on the left side
            textStyle: {
                fontSize: 20, // Custom font size for vertical axis labels
            },
            // gridlines: {
            //     color: "transparent", // Make vertical gridlines transparent to effectively hide them
            // },
        }
    }
    const handleLabelClick = (index) => {
        console.log("dataArticles394=", dataArticles)
        // alert(index)
        //

        if (isChecked) {

            if (selectedValue == "viewed") {
                const url = `/knowledgerepo/single-article?id=${currentweeksViewedArticle[index]?.id}`;
                if (url) {
                    window.open(url, "_blank");
                }
            } else if (selectedValue === "recent") {
                const url = `/knowledgerepo/single-article?id=${resentWeekFiveArticles[index]?.id}`;
                if (url) {
                    window.open(url, "_blank");
                }
            }
            else if (selectedValue == "liked") {
                const url = `/knowledgerepo/single-article?id=${currentWeekLikedPosts[index]?.id}`;
                if (url) {
                    window.open(url, "_blank");
                }
            }
        }
        if (!isChecked) {

            if (selectedValue == "viewed") {
                const url = `/knowledgerepo/single-article?id=${currentMonthsViewedArticle[index]?.id}`;
                if (url) {
                    window.open(url, "_blank");
                }
            } else if (selectedValue === "recent") {
                const url = `/knowledgerepo/single-article?id=${resentMonthFiveArticles[index]?.id}`;
                if (url) {
                    window.open(url, "_blank");
                }
            }
            else if (selectedValue == "liked") {
                const url = `/knowledgerepo/single-article?id=${currentMonthLikedPosts[index]?.id}`;
                if (url) {
                    window.open(url, "_blank");
                }
            }
        }
        // 

    };



    // 
    const handleChange = (selectedOption) => {
        console.log(`Selected:`, selectedOption);
        setSelectedTenant(null);
        setCategories(selectedOption.categgory.join(","));
        setLoading(false);
        // alert("dfdf")
    };

    const getAllTheArticles = async () => {
        const requestFst = {
            method: "GET",
            url: `${API_BASE_URL}/wp-json/custom-like/v1/liked-posts`,
        };
        axios
            .get(`${API_BASE_URL}/wp-json/custom-api/v1/get-data`, config)
            .then((res) => {
                logApiRequest(requestFst, res);

                setOptions(
                    res.data.map((item) => ({
                        value: item.id,
                        label: item.tenent,
                        categgory: item.category,
                    }))
                );

                const selectedOption = res.data.filter((data) => {
                    if (data.tenent_user_id == currentUserId) {
                        return data;
                    }
                });
                console.log("selectedOption", selectedOption);
                if (localStorage.getItem("roles") == "editor") {
                    if (selectedOption.length > 0) {
                        setOptions(
                            selectedOption.map((item) => ({
                                value: item.id,
                                label: item.tenent,
                                categgory: item.category,
                            }))
                        );
                        setSelectedTenant({
                            value: selectedOption[0].id,
                            label: selectedOption[0].tenent,
                            categgory: selectedOption[0].category,
                        });
                    } else {
                        navigate("/default-page");
                    }
                }
                let getArticleEndPoint;
                // https://your-domain.com/wp-json/custom/v1/posts_by_categories?categories=1,2,3
                const defaultCategory =
                    selectedOption.length > 0
                        ? selectedOption[0].category.join(", ")
                        : "";
                console.log(
                    "line81=",

                    defaultCategory
                );
                if (categories == "" && selectedOption.length == 0) {
                    getArticleEndPoint = `${API_BASE_URL}/wp-json/custom/v1/posts`;
                } else {
                    console.log("line132=");
                    if (categories == "") {
                        getArticleEndPoint = `${API_BASE_URL}/wp-json/custom/v1/posts_by_categories?categories=${defaultCategory}`;
                    } else {
                        getArticleEndPoint = `${API_BASE_URL}/wp-json/custom/v1/posts_by_categories?categories=${categories}`;
                    }
                }

                let request = {
                    method: "GET",
                    url: getArticleEndPoint,
                };
                axios
                    .get(getArticleEndPoint, config)
                    .then((res) => {
                        console.log("line26=", res.data);
                        logApiRequest(request, res);
                        setTotalArticle(res.data.length > 0 ? res.data.length : 0);
                        let noOfLike = 0;
                        for (let i = 0; i < res.data.length; i++) {
                            noOfLike = noOfLike + res.data[i].likes_count;
                        }

                        setTotalLike(noOfLike > 0 ? noOfLike : 0);
                        console.log("line52");
                        // Filter posts for the current week
                        let sevenDaysAgo = new Date();
                        sevenDaysAgo.setDate(new Date().getDate() - 7);
                        // Get the Unix timestamp in milliseconds
                        let sevenDaysAgoTimestampMillis = sevenDaysAgo.getTime();

                        const today = new Date();
                        const startOfWeek = new Date(
                            today.setDate(today.getDate() - today.getDay())
                        );
                        const startDate = startOfWeek.toISOString().split("T")[0];

                        const endDate = new Date().toISOString().split("T")[0];

                        console.log(`start date=${startDate}  endDate=${endDate}`);
                        const currentWeekPosts = res.data.filter((post) => {
                            const postDate = new Date(post.date).getTime();

                            return (
                                postDate >= sevenDaysAgoTimestampMillis &&
                                postDate <= new Date().getTime()
                            );
                        });
                        console.log("weekpost=", currentWeekPosts);

                        setResentWeekFiveArticles(
                            currentWeekPosts.length > 0
                                ? currentWeekPosts.slice(0, 5)
                                : currentWeekPosts
                        );
                        const sortPostsDataByLike = res.data
                            .filter((post) => post.likes_count > 0) // Filter out posts with likes_count of 0
                            .sort((a, b) => {
                                // Sort by likes_count in descending order
                                return b.likes_count - a.likes_count;
                            });

                        const sortCurrentWeekPostsDataByLike = sortPostsDataByLike.filter(
                            (post) => {
                                return (
                                    post.liked_timestamp * 1000 >= sevenDaysAgoTimestampMillis &&
                                    post.liked_timestamp * 1000 <= new Date().getTime()
                                );
                            }
                        );

                        console.log("1qeqwe2", sortCurrentWeekPostsDataByLike);

                        setNewArticleThisWeek(
                            currentWeekPosts.length > 0 ? currentWeekPosts.length : 0
                        );

                        setCurrentWeekLikedPosts(
                            sortCurrentWeekPostsDataByLike.length > 5
                                ? sortCurrentWeekPostsDataByLike.slice(0, 5)
                                : sortCurrentWeekPostsDataByLike
                        );

                        const sortWeeksViewedArticlesByTime = res.data.sort((a, b) => {
                            if (b.unique_author_views !== a.unique_author_views) {
                                return b.unique_author_views - a.unique_author_views;
                            }
                        });
                        const sortWeeksViewedArticles = sortWeeksViewedArticlesByTime.sort(
                            (a, b) => {
                                if (b.unique_author_views !== a.unique_author_views) {
                                    return b.unique_author_views - a.unique_author_views;
                                }
                            }
                        );
                        console.log("ViewedArticles=", sortWeeksViewedArticles);
                        //
                        const currentWeekViewedPosts = sortWeeksViewedArticles.filter(
                            (post) => {
                                console.log(
                                    `postdate141= ${post.post_view_time_stamp
                                    } 7days ago=${sevenDaysAgoTimestampMillis} currentdate=${new Date().getTime()}`
                                );

                                console.log(
                                    "line143=",
                                    post.post_view_time_stamp >= sevenDaysAgoTimestampMillis &&
                                    post.post_view_time_stamp <= new Date().getTime()
                                );

                                return (
                                    post.post_view_time_stamp * 1000 >=
                                    sevenDaysAgoTimestampMillis &&
                                    post.post_view_time_stamp * 1000 <= new Date().getTime()
                                );
                            }
                        );
                        console.log("currentWeekViewedPosts=", currentWeekViewedPosts);

                        //

                        setCurrentWeeksViewedArticle(
                            currentWeekViewedPosts.length > 5
                                ? currentWeekViewedPosts.slice(0, 5)
                                : currentWeekViewedPosts
                        );
                        // Filter posts for the current month
                        // const today = new Date();

                        let MonthDaysAgo = new Date();
                        MonthDaysAgo.setDate(new Date().getDate() - 30);

                        // Get the Unix timestamp in milliseconds
                        let monthAgoTimestampMillis = MonthDaysAgo.getTime();

                        // const startOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
                        // const startDateMonth = startOfMonth.toISOString().split('T')[0];
                        // const endDateMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0).toISOString().split('T')[0];
                        // console.log(`start date=${startDateMonth}  endDate=${endDateMonth}`)

                        const currentMonthPosts = res.data.filter((post) => {
                            const postDate = new Date(post.date).getTime();
                            return (
                                postDate >= monthAgoTimestampMillis &&
                                postDate <= new Date().getTime()
                            );
                        });
                        setResentMonthFiveArticles(
                            currentMonthPosts.length > 5
                                ? currentMonthPosts.slice(0, 5)
                                : currentMonthPosts
                        );
                        //

                        console.log(
                            "sortWeeksViewedArticlesByTime",
                            sortWeeksViewedArticlesByTime
                        );

                        //
                        const currentMonthsViewedPosts = sortWeeksViewedArticles.filter(
                            (post) => {
                                return (
                                    post.post_view_time_stamp * 1000 >= monthAgoTimestampMillis &&
                                    post.post_view_time_stamp * 1000 <= new Date().getTime()
                                );
                            }
                        );
                        console.log("currentWeekViewedPosts=", currentWeekViewedPosts);

                        //

                        //
                        setCurrentMonthssViewedArticle(
                            currentMonthsViewedPosts.length > 5
                                ? currentMonthsViewedPosts.slice(0, 5)
                                : currentMonthsViewedPosts
                        );

                        const sortCurrentMonthPostsDataByLike = sortPostsDataByLike.filter(
                            (post) => {
                                return (
                                    post.liked_timestamp * 1000 >= monthAgoTimestampMillis &&
                                    post.liked_timestamp * 1000 <= new Date().getTime()
                                );
                            }
                        );

                        setCurrentMonthLikedPosts(
                            sortCurrentMonthPostsDataByLike.length > 5
                                ? sortCurrentMonthPostsDataByLike.slice(0, 5)
                                : sortCurrentMonthPostsDataByLike
                        );
                        setLoading(true);
                    })
                    .catch((err) => {
                        logApiRequest(request, err.response || { status: err.message });
                        console.log(err);
                    });
            })
            .catch((err) => {
                console.log(err);
                logApiRequest(requestFst, err.response || { status: err.message });
            });
    };

    const getParentCategories = () => {
        const request = {
            method: "GET",
            url: "/wp-json/custom-category/v1/get-parent-categories?page=-1",
        };
        axios
            .get(
                `${API_BASE_URL}/wp-json/custom-category/v1/get-parent-categories?page=-1`,
                config
            )
            .then((res) => {
                console.log("categoryres298=", res);
                logApiRequest(request, res);
                setTotalCategories(res.data.length > 0 ? res.data.length : 0);
                // setLoading(true)
            })
            .catch((err) => {
                logApiRequest(request, err.response || { status: err.message });
                console.log(err);
            });
    };

    useEffect(() => {
        getAllTheArticles();
        thisWeakMostLikedArticles();
        getParentCategories();

        // getTenentData()
        // }, [categories, selectedTenant, loading]);
    }, [loading]);
    const usersRolesData = [
        ["Task", "Hours per Day"],
        ["Reader", user_roles.reader],
        ["Author", user_roles.author],
        ["Tenant Admin", user_roles.editor],
        // ["Admin", roles.admin]

    ];

    const usersRolesOptions = {
        // title: "Total Users",
        pieHole: 0.6,
        is3D: false,
        pieSliceText: 'value', // Display exact data values
        slices: {
            0: { color: '#929EED' },  // Work section, red color
            1: { color: '#92ED98' },  // Eat section, green color
            2: { color: '#FFFF4F' },  // Commute section, blue color
            3: { color: '#FF33A1' },  // Watch TV section, pink color
            4: { color: '#33C4FF' },  // Sleep section, light blue color
        },
        pieSliceText: 'value', // Display exact data values
        legend: {
            position: 'bottom', // Move legend below the chart
            textStyle: { fontSize: 18 }, // Customize legend font size
        },
        pieSliceTextStyle: {
            fontSize: 16, // Customize data label font size
            color: 'black', // Make chart values black
        },
        tooltip: {
            text: 'value', // Show only the value in the tooltip
            fontSize: 16,
        },
        chartArea: {
            width: '100%',
            height: '80%', // Adjust chart area to leave space for the legend
        },
        annotations: {
            alwaysOutside: false,
            textStyle: {
                fontSize: 14,
                color: 'black',
            },
        },
        titlePosition: 'center', // Move the title to the center
        pieStartAngle: 180, // Optional: Adjust the starting angle if needed
    };
    //

    const sotrage_data = [
        ["Storage Used", "MB"],
        // ["Storage Used", "MB"],

        ["Avilable Space", ((parseFloat(storage.totalStorage) - parseFloat(storage.usedStorage)) / parseFloat(storage.totalStorage)) * 100],
        ["Used Space", (parseFloat(storage.usedStorage) / parseFloat(storage.totalStorage)) * 100],
        // // ["Commute", 20],
        // ["Watch TV", 2],
        // ["Sleep", 7],
    ];

    const sotrage_options = {
        // title: "So, how was your day?",
        slices: {
            0: {
                color: "#33C4FF",
                // enableInteractivity: false,
            },  // Work section, red color
            1: {
                color: '#FF4209'
            },  // Eat section, green color
            // 2: { color: '#FFFF4F' },  // Commute section, blue color
            // 3: { color: '#FF33A1' },  // Watch TV section, pink color
            // 4: { color: '#33C4FF' },  // Sleep section, light blue color
        },
        // pieSliceText: 'value', // Display exact data values
        legend: {
            position: 'bottom', // Move legend below the chart
            textStyle: { fontSize: 14 }, // Customize legend font size
        },
        pieHole: 0.5,
        // width: 600,
        height: 300,
        // pieStartAngle: 96, // Rotate chart by 90 degrees
        chartArea: {
            width: '100%',
            height: '80%', // Adjust chart area to leave space for the legend
        },
        legend: {
            position: 'bottom', // Move legend below the chart
            textStyle: { fontSize: 18 }, // Customize legend font size
        },
        pieSliceTextStyle: {
            fontSize: 14, // Customize data label font size
            color: 'black', // Make chart values black
        },
        annotations: {
            alwaysOutside: false,
            textStyle: {
                fontSize: 12,
                color: 'black',
            },
        },
        tooltip: {
            // trigger: 'focus', // Display tooltip on hover
            text: 'percentage', // Show percentage value only
            textStyle: {
                fontSize: 12,
                color: 'black',
            },
            // showColorCode: true, // Show color swatch in the tooltip
        },
        pieSliceText: 'percentage', // Display percentage on the slices
    };
    // 
    return (
        <div>
            <div className="col-12 hamburger">
                <InnerHamburgerNavigation />
            </div>
            <div className="top-nav">
                {/* <TopNavBar /> */}
                {!bearerToken ? <OpenPlatformNavbar /> : <NewTopNavBar />}
            </div>
            {/* navbar */}
            <HamburgerNavigation />

            {console.log("loading365=", loading)}
            <div className="analiyics-dasboard-maindiv container-fluid pb-5">
                {loading ? (
                    <div className="row ">
                        {/* <div className='col-lg-2 col-md-2 col-sm-1'> */}

                        {/* </div> */}
                        <div className="col-lg-12 col-md-12 col-sm-10 mt-5">
                            <div className="content-main-div">
                                <div className="container-fluid">
                                    {bearerToken &&
                                        userRolles !== "author" &&
                                        userRolles !== "subscriber" && (
                                            <div>
                                                {!bearerToken ? (
                                                    ""
                                                ) : (
                                                    <div className="col-lg-3 col-md-3 col-sm-5 pb-4 pt-3 pe-4 d-none">
                                                        {selectedTenant?.length > 0 ? (
                                                            <Select
                                                                value={selectedTenant}
                                                                options={options}
                                                                onChange={handleChange}
                                                                placeholder="Select a Tenant "
                                                            // isDisabled={isDisabled}
                                                            />
                                                        ) : (
                                                            <Select
                                                                value={selectedTenant}
                                                                options={options}
                                                                onChange={handleChange}
                                                                placeholder="Select a Tenant"
                                                                isDisabled={isDisabled}
                                                            />
                                                        )}
                                                        {/* {selectedTenant?.length == 0 ? <Select
                    value={selectedTenant}
                    options={options}
                    onChange={handleChange}
                    placeholder="Select a Tenant "
                    isDisabled={isDisabled}

                /> : ""} */}
                                                    </div>
                                                )}
                                            </div>
                                        )}
                                    <div className="row">
                                        <div className="col-lg-3 col-md-3 col-sm-12">
                                            {/* <div className="article-count-container top-box-container blue-conatiner">
                                                <p className="top-contaier-heading ">Total Articles</p>
                                                <div className="">
                                                    <div className="number-count">{totalArticle}</div>
                                                    <div className="analitys-img">{FaLinkedin}</div>
                                                </div>
                                            </div> */}
                                        </div>
                                        <div className="col-lg-3 col-md-3 col-sm-12">
                                            <div className="article-count-container top-box-container blue-conatiner">
                                                <p className="top-contaier-heading ">Total Articles</p>
                                                <div className="">
                                                    <div className="number-count">{totalArticle}</div>
                                                    <div className="analitys-img">{FaLinkedin}</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-3 col-md-3 col-sm-12">
                                            <div className="article-count-container blue-conatiner top-box-container ">
                                                <p className="top-contaier-heading ">Total Likes</p>
                                                <div className="">
                                                    <div className="number-count">{totalLike}</div>
                                                    <div className="analitys-img">{FaLinkedin}</div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-3 col-md-3 col-sm-12">
                                            {" "}
                                            <div className="article-count-container blue-conatiner top-box-container ">
                                                <p className="top-contaier-heading ">
                                                    New articles
                                                </p>
                                                <div className="">
                                                    <div className="number-count">
                                                        {newArticleThisWeek}
                                                    </div>
                                                    <div className="analitys-img">{FaLinkedin}</div>
                                                </div>
                                            </div>
                                        </div>
                                        {/* <div className="col-3"> <div className="article-count-container blue-conatiner">
                                            <p className="top-contaier-heading ">
                                                Total Categories
                                            </p>
                                            <div className=''>
                                                <div className="number-count">
                                                    {totalCategories}
                                                </div>
                                                <div className="analitys-img">{FaLinkedin}</div>
                                            </div>


                                        </div></div> */}
                                    </div>
                                    <div className="row">
                                        <div className="col-lg-3 col-md-3 col-sm-12 ">
                                            <div className="top-container-main-div row">
                                                <div className="article-content-main-div ">
                                                    <div className="article-count-container   ">
                                                        <div>
                                                            <h4>Storage Capacity </h4>
                                                            <h4>Total Capacity:{storage.totalStorage}GB</h4>
                                                            <Chart
                                                                chartType="PieChart"
                                                                data={sotrage_data}
                                                                options={sotrage_options}
                                                                width="100%"
                                                                height="350px"
                                                            />
                                                        </div>
                                                        <div>
                                                            <h4>Total Users:{user_roles.author + user_roles.editor + user_roles.reader}</h4>
                                                        </div>
                                                        <Chart
                                                            chartType="PieChart"
                                                            width="100%"
                                                            height="300px"
                                                            data={usersRolesData}
                                                            options={usersRolesOptions}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="col-lg-9 col-md-9 col-sm-12">
                                            <div className="top-container-main-div row">
                                                <div className="article-content-main-div ">
                                                    <div className="article-count-container blue-conatiner mt-4 py-3 pb-4">


                                                        {/* <p className="top-contaier-heading ">
                                                            Most recent Articles of the Month/Week
                                                        </p> */}
                                                        {/* tabs start */}
                                                        <Tab.Container
                                                            id="left-tabs-example"
                                                            defaultActiveKey="first"
                                                        >
                                                            <Row>
                                                                <div className="d-flex justify-content-between align-items-baseline">
                                                                    <div className="pb-3">
                                                                        <select id="authorDropdown" value={selectedValue} onChange={handleChangeSelectArticles}>
                                                                            <option value="recent">Most recent Articles</option>
                                                                            <option value="viewed">Most Viewed Articles</option>
                                                                            <option value="liked">Most Liked Articles</option>
                                                                        </select>
                                                                    </div>

                                                                    <div className="d-flex">

                                                                        <div>
                                                                            <label className="pe-2 fw-bold">Month</label>
                                                                            <label className="toggle-switch">

                                                                                <input
                                                                                    type="checkbox"
                                                                                    // checked={createUsersFormData.toggle_status?cre}
                                                                                    checked={isChecked}
                                                                                    onChange={handleToggle}
                                                                                />
                                                                                <span className="slider round"></span>
                                                                            </label>
                                                                            <label className="ps-1 fw-bold">Week</label>
                                                                        </div>
                                                                        <div className="d-none">
                                                                            {/* <Col sm={4}> */}
                                                                            <Nav variant="pills" className="flex-column">
                                                                                <Nav.Item>
                                                                                    <Nav.Link
                                                                                        className="rounded-months"
                                                                                        eventKey="first"
                                                                                    >
                                                                                        Month
                                                                                    </Nav.Link>
                                                                                </Nav.Item>
                                                                            </Nav>

                                                                            {/* </Col> */}
                                                                            {/* <Col sm={4}> */}
                                                                            <Nav variant="pills" className="flex-column">
                                                                                <Nav.Item>
                                                                                    <Nav.Link
                                                                                        className="rounded-months"
                                                                                        eventKey="second"
                                                                                    >
                                                                                        Week
                                                                                    </Nav.Link>
                                                                                </Nav.Item>
                                                                            </Nav>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                                <Tab.Content>
                                                                    <Tab.Pane eventKey="first">
                                                                        {dataArticles[1][0] == undefined ? <h4 className="text-center pt-5">No Articles Found</h4> :
                                                                            <Chart
                                                                                chartType="BarChart"
                                                                                width="100%"
                                                                                height="600px"
                                                                                data={dataArticles}
                                                                                options={optionsArticles}
                                                                                chartEvents={[
                                                                                    {
                                                                                        eventName: "select",
                                                                                        callback: ({ chartWrapper }) => {
                                                                                            const selectedItem = chartWrapper.getChart().getSelection()[0];
                                                                                            if (selectedItem) {
                                                                                                const rowIndex = selectedItem.row;
                                                                                                handleLabelClick(rowIndex);
                                                                                            }
                                                                                        },
                                                                                    },
                                                                                ]}
                                                                            />
                                                                        }
                                                                        <div className="d-none">
                                                                            {showArticles.length > 0 ? (
                                                                                showArticles.map(
                                                                                    (res, index) => {
                                                                                        // let regex = /\(([^)]+)\)/;
                                                                                        // let match = regex.exec(res.category_name
                                                                                        //     .name);
                                                                                        // let valueWithinParentheses = match[1];

                                                                                        function truncateSentence(
                                                                                            sentence,
                                                                                            maxChars
                                                                                        ) {
                                                                                            let words = sentence.split(" ");
                                                                                            console.log("line189", words);
                                                                                            if (sentence.length > maxChars) {
                                                                                                return (
                                                                                                    sentence.substring(
                                                                                                        0,
                                                                                                        maxChars
                                                                                                    ) + " ..."
                                                                                                );
                                                                                            }
                                                                                            return sentence;
                                                                                        }
                                                                                        return (
                                                                                            <div
                                                                                                className="post-main-div"
                                                                                                onClick={() =>
                                                                                                    gotToArticlePage(res.id)
                                                                                                }
                                                                                            >
                                                                                                {/* <div className="Category-name">
                                                                                {truncateSentence(res?.title.rendered, 32)}
                                                                            </div> */}

                                                                                                <div className="article-containt-maindiv Category-name">
                                                                                                    {/* <div className="post-title pt-2" dangerouslySetInnerHTML={{ __html: truncateSentence(res?.excerpt?.rendered, 40) }} /> */}



                                                                                                    <div>
                                                                                                        {truncateSentence(
                                                                                                            res?.title.rendered,
                                                                                                            32
                                                                                                        )}
                                                                                                    </div>
                                                                                                    <div className="article"></div>
                                                                                                    <div className="like-main-div">
                                                                                                        <div className="like-main-img-div">
                                                                                                            <img
                                                                                                                width={30}
                                                                                                                src={ViewImg}
                                                                                                                alt=""
                                                                                                            />
                                                                                                        </div>
                                                                                                        <div className="count-number-div">
                                                                                                            {console.log(
                                                                                                                "line701=",
                                                                                                                res.unique_author_views
                                                                                                            )}
                                                                                                            <span className="like-count ps-1 mt-0">
                                                                                                                {res.unique_author_views ==
                                                                                                                    ""
                                                                                                                    ? 0
                                                                                                                    : res.unique_author_views >
                                                                                                                        99
                                                                                                                        ? "99+"
                                                                                                                        : res.unique_author_views}
                                                                                                            </span>
                                                                                                        </div>
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                        );
                                                                                    }
                                                                                )
                                                                            ) : (
                                                                                <h4 className="text-center fw-bold py-5">
                                                                                    No Article found
                                                                                </h4>
                                                                            )}
                                                                        </div>
                                                                    </Tab.Pane>
                                                                    <Tab.Pane eventKey="second">
                                                                        {resentWeekFiveArticles.length > 0 ? (
                                                                            resentWeekFiveArticles.map(
                                                                                (res, index) => {
                                                                                    // let regex = /\(([^)]+)\)/;
                                                                                    // let match = regex.exec(res.category_name
                                                                                    //     .name);
                                                                                    // let valueWithinParentheses = match[1];

                                                                                    function truncateSentence(
                                                                                        sentence,
                                                                                        maxChars
                                                                                    ) {
                                                                                        console.log("sentace=", sentence);
                                                                                        let words = sentence.split(" ");
                                                                                        console.log("line189", words);
                                                                                        if (sentence.length > maxChars) {
                                                                                            return (
                                                                                                sentence.substring(
                                                                                                    0,
                                                                                                    maxChars
                                                                                                ) + " ..."
                                                                                            );
                                                                                        }
                                                                                        return sentence;
                                                                                    }
                                                                                    return (
                                                                                        <div
                                                                                            onClick={() =>
                                                                                                gotToArticlePage(res.id)
                                                                                            }
                                                                                            className="post-main-div"
                                                                                        >
                                                                                            {/* <div className="Category-name">
                                                                                {truncateSentence(res?.title.rendered, 32)}
                                                                            </div> */}

                                                                                            <div className="article-containt-maindiv Category-name">
                                                                                                {/* <div className="post-title pt-2" dangerouslySetInnerHTML={{ __html: truncateSentence(res?.excerpt?.rendered, 40) }} /> */}
                                                                                                <div>
                                                                                                    {truncateSentence(
                                                                                                        res?.title.rendered,
                                                                                                        32
                                                                                                    )}
                                                                                                </div>
                                                                                                <div className="like-main-div">
                                                                                                    <div className="like-main-img-div">
                                                                                                        <img
                                                                                                            width={30}
                                                                                                            src={ViewImg}
                                                                                                            alt=""
                                                                                                        />
                                                                                                    </div>
                                                                                                    <div className="count-number-div">
                                                                                                        {console.log(
                                                                                                            "line701=",
                                                                                                            res.unique_author_views
                                                                                                        )}
                                                                                                        <span className="like-count ps-1 mt-0">
                                                                                                            {res.unique_author_views ==
                                                                                                                ""
                                                                                                                ? 0
                                                                                                                : res.unique_author_views >
                                                                                                                    99
                                                                                                                    ? "99+"
                                                                                                                    : res.unique_author_views}
                                                                                                        </span>
                                                                                                    </div>
                                                                                                </div>
                                                                                            </div>
                                                                                        </div>
                                                                                    );
                                                                                }
                                                                            )
                                                                        ) : (
                                                                            <h4 className="text-center fw-bold py-5">
                                                                                No Article found
                                                                            </h4>
                                                                        )}
                                                                    </Tab.Pane>
                                                                </Tab.Content>
                                                            </Row>
                                                        </Tab.Container>
                                                        {/* tabs end */}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                        {/* <div className='col-lg-2 col-md-2 col-sm-1'> */}

                        {/* </div> */}
                    </div>
                ) : (
                    <div className="d-flex align-items-center mt-5 pt-5 justify-content-center">
                        <Spinner />
                    </div>
                )}
            </div>
        </div >
    );
};

export default AnaliticsDasboard;
